import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useMarking from '../../../../../../hooks/maestro/useMarking'
import Countdown from 'react-count-down'
import { toggleAlertModule } from '../../../../../../store/actions/alert.actions'
import ButtonStartIcon from '../../../../../button/ButtonStartIcon'

const SaveButtonStudentView = () => {
  const mode = useSelector((state) => state?.classMarking?.mode || [])
  const student = useSelector((state) => state?.classMarking?.student)
  const currentMode = mode?.find((item) => student?._id === item.studentId)
  const alertSave = useSelector((state) => state?.alert?.save || {})
  const dispatch = useDispatch()
  const { updateStudentMarkingByClassIdAndUlId } = useMarking()

  const onSave = async () => {
    await updateStudentMarkingByClassIdAndUlId(student, true)
  }

  const OPTIONS = {
    endDate: currentMode?.endDate || new Date(),
    cb: () => onSave()
  }

  useEffect(() => {
    if (currentMode) {
      if (!alertSave.mode || !alertSave.onSave) {
        dispatch(toggleAlertModule(false, 'Classes', 'marking', onSave, alertSave.onDontSave))
      }
    }
  }, [currentMode, alertSave])

  return (
    <>
      {currentMode?.endDate && (
        <div style={{ display: 'none' }}>
          {' '}
          <Countdown options={OPTIONS} />
        </div>
      )}
      {mode.length > 0 && (
        <ButtonStartIcon
          disabled={currentMode?.mode === 'saving'}
          startIcon={['fal', 'check']}
          loading={currentMode?.mode === 'saving'}
          onClick={onSave}
          className='font-bold '
        >
          Save
        </ButtonStartIcon>
      )}
    </>
  )
}

export default SaveButtonStudentView
